import LazyLoad from "vanilla-lazyload";

// Image lazy load
window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy'
});


jQuery(document).ready(function(i) {

if( i(".section.is-first .background-layer.is-image").length ) {
        if (i(".section.is-first .background-layer.is-image").css("background-image") != 'none') {
        var o = i(".section.is-first .background-layer.is-image").css("background-image").match(/url\(["|']?([^"']*)["|']?\)/)[1];
        i("<img/>").attr("src", o).on("load", function() {
            setTimeout(function() {
                i(".section.is-first .background-layer.is-image").removeClass("background-loading");
                i(".section.is-first .section-row-headline").addClass("animate");
            }, 30);
        })
        }
    }

if( i(".section.is-first .background-layer.is-video video").length ) {
    i(".section.is-first .background-layer.is-video video").on('canplay', function () {
        setTimeout(function() {
                i(".section.is-first .background-layer.is-video video").removeClass("background-loading");
                i(".section.is-first .section-row-headline").addClass("animate");
            }, 30);
    });

}


if( i("section.mediabanner .section-wrapper .section-row-media > img").length ) {
        var o = i("section.mediabanner .section-wrapper .section-row-media > img").get(0).src.match(/url\(["|']?([^"']*)["|']?\)/)[1];
        i("<img/>").attr("src", o).on("load", function() {
        console.log("loaded media");
            setTimeout(function() {
                // i("section.mediabanner .section-wrapper .section-row-media > img").removeClass("background-loading");
            }, 30);
        })
                i(".section.mediabanner .section-row-headline").addClass("animate");
    }

if( i("section.mediabanner .section-wrapper .section-row-media > video").length ) {
    i("section.mediabanner .section-wrapper .section-row-media > video").on('canplay', function () {
        console.log("loaded media");
        setTimeout(function() {
                // i(".section.is-first .background-layer.is-video video").removeClass("background-loading");
            }, 30);
    });
                i(".section.mediabanner .section-row-headline").addClass("animate");

}

function startcounter(counter_container){
                counter_container.querySelectorAll('.counter').forEach(counter => {

                const start = Number(counter.dataset.start);
                const count = Number(counter.dataset.count);
                const duration = Number(counter.dataset.duration);
                const max = Number(counter.dataset.max);
                const suffix = counter.dataset.suffix || '';

                // const duration = 1000;
                const startTime = performance.now();

                function update(time) {

                    const progress = Math.min(
                        (time - startTime) / duration,
                        1
                    );

                    const value = Math.floor(
                        start + (max - start) * progress
                    );

                    counter.textContent = value.toLocaleString('de-DE');

                    if (progress < 1) {
                        requestAnimationFrame(update);
                    } else {
                        // Reached max → add suffix
                        if(count > max){
                        counter.textContent =
                            max.toLocaleString('de-DE') + suffix;
                        }
                    }
                }

                requestAnimationFrame(update);
            });
        }
 i(window).scroll(function() {
        // var e = i(".section-hero.rautebanner"),
        var e = i(".section-hero.mediabanner"),
        t = "header-shrunk";
        if (100 <= i(window).scrollTop()) {
            e.addClass(t);
        }else{
            e.removeClass(t);
        }
})

const counterSection = document.querySelector('.section-row-counter');

if (counterSection) {

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                startcounter(entry.target); 

                // Stop observing after it has started
                observer.unobserve(entry.target);
            }

        });

    }, {
        threshold: 0.2
    });

    observer.observe(counterSection);
}


      const lhcards = document.querySelectorAll('.layout-gray-hover.teaser-item');

        let hoverinterval;
        let currentAuto = null;
        let userHovering = false;

        function showRandomHover() {
            if (userHovering) return;

            if (currentAuto) {
                currentAuto.classList.remove('auto-hover');
            }

            let availableCards = [...lhcards];

            if (currentAuto) {
                availableCards = availableCards.filter(
                    card => lhcards !== currentAuto
                );
            }

            const randomCard =
                availableCards[Math.floor(Math.random() * availableCards.length)];

            randomCard.classList.add('auto-hover');
            currentAuto = randomCard;
        }

        function startAutoHover() {
            clearInterval(hoverinterval);

            showRandomHover(); // immediately show one

            hoverinterval = setInterval(showRandomHover, 3000);
        }
        // const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const canHover = true;

        lhcards.forEach(card => {
            card.addEventListener('mouseenter', () => {
                userHovering = true;
                if (canHover) {
                console.log("entered here added flipped");

                    card.classList.add('flipped');
                }
                if (currentAuto) {
                    currentAuto.classList.remove('auto-hover');
                }
            });

            card.addEventListener('mouseleave', () => {
                userHovering = false;
                if (canHover) {
                    card.classList.remove('flipped');
                }
            });

            card.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log("toggled flipped");
                card.classList.toggle('flipped');
            });
        });

        if (lhcards.length) {
            startAutoHover();
        }

});